export default ['$scope', '$location', 'StaffAccountApplication',
  // eslint-disable-next-line func-names
  function ($scope, $location, StaffAccountApplication) {
    this.filters = { accountNumbers: $location.search().accountNumbers || 'false' };
    this.updateFilters = () => $location.search(_.merge($location.search(), this.filters));
    this.hasMetadataLoaded = false;

    const setQueryParamDefaults = () => {
      if (!$location.search().page) { $location.search('page', 1); }
      if (!$location.search().limit) { $location.search('limit', 50); }
      if (!$location.search().orderBy) { $location.search('orderBy', 'submitted'); }
      if (!$location.search().reverse) { $location.search('reverse', 'true'); }

      // the status is an empty array when the user unchecks all the checkboxes
      if (!$location.search().status) { $location.search('status', [1, 2, 4, 5, 8, 9, 10]); }
    };

    const parseFilters = () => {
      this.filters.accountType = $location.search().accountType ? $location.search().accountType : undefined;
      this.filters.pmApproval = $location.search().pmApproval ? $location.search().pmApproval : undefined;
      this.filters.status = $location.search().status;
      // eslint-disable-next-line max-len
      this.filters.associatedAgreementStatus = $location.search().associatedAgreementStatus ? $location.search().associatedAgreementStatus : undefined;
      this.filters.portfolioModel = $location.search().portfolioModel ? $location.search().portfolioModel : undefined;
      this.filters.clientSearch = $location.search().clientSearch ? $location.search().clientSearch : '';
      this.page = $location.search().page;
      this.limit = $location.search().limit;
      this.orderBy = $location.search().orderBy;
      this.reverse = $location.search().reverse;
    };

    const loadAccountApplications = () => {
      setQueryParamDefaults();
      parseFilters();

      this.applications = null;
      return StaffAccountApplication.list({
        filters: this.filters,
        page: this.page,
        limit: this.limit,
        orderBy: this.orderBy,
        reverse: this.reverse,
      }, applications => {
        this.appStatuses = applications.metadata.accountApplicationStatusMeta;
        this.accountTypes = applications.metadata.accountTypeMeta;
        this.portfolioModels = applications.metadata.portfolioModelMeta;
        this.associatedAgreementStatuses = applications.metadata.associatedAgreementStatusMeta;
        this.pmApproval = applications.metadata.pmApprovalStatusMeta;
        this.hasMetadataLoaded = true;
        this.applications = applications;
      });
    };

    $scope.$on('$routeUpdate', () => loadAccountApplications());

    setQueryParamDefaults();
    loadAccountApplications();

    return this;
  },
];
